"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _layout = require("../../layout");

var _constants = require("../constants");

var _html = require("../html");

var _interfaces = require("../interfaces");

var _TableHeaderButton = _interopRequireDefault(require("./TableHeaderButton"));

var _helperComponents = require("./helperComponents");

var _core = require("@emotion/core");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var TableHeader = function TableHeader(_ref) {
  var actionColumnIndex = _ref.actionColumnIndex,
      actionHeader = _ref.actionHeader,
      activeSortId = _ref.activeSortId,
      _ref$ascendingTitleTe = _ref.ascendingTitleText,
      ascendingTitleText = _ref$ascendingTitleTe === void 0 ? _constants.defaultProps.ascendingTitleText : _ref$ascendingTitleTe,
      columns = _ref.columns,
      _ref$descendingTitleT = _ref.descendingTitleText,
      descendingTitleText = _ref$descendingTitleT === void 0 ? _constants.defaultProps.descendingTitleText : _ref$descendingTitleT,
      hasActionColumn = _ref.hasActionColumn,
      hasStickyHeader = _ref.hasStickyHeader,
      isStriped = _ref.isStriped,
      onSort = _ref.onSort,
      sortDirection = _ref.sortDirection,
      spacing = _ref.spacing,
      isExpandable = _ref.isExpandable;
  var isActionCustomPosition = actionColumnIndex || actionColumnIndex === 0;
  var baseColumns = columns.map(function (_ref2, index) {
    var header = _ref2.header,
        _ref2$headerCellType = _ref2.headerCellType,
        headerCellType = _ref2$headerCellType === void 0 ? _constants.defaultColumnAttributes.headerCellType : _ref2$headerCellType,
        sortId = _ref2.sortId,
        textAlign = _ref2.textAlign,
        width = _ref2.width;
    var isCurrentSortedColumn = activeSortId === sortId;
    var isSortable = sortId !== undefined && !!onSort;
    var columnSortDirection = isCurrentSortedColumn ? sortDirection : _interfaces.SortDirection.None;
    var isCellTypeHeader = headerCellType === _interfaces.CellType.Header;
    var Cell = isCellTypeHeader ? _html.ThElement : _html.TdElement;

    var headerTypeCellProps = _objectSpread({}, isCellTypeHeader && {
      scope: 'col',
      isSortable: isSortable,
      'aria-sort': isSortable ? columnSortDirection : undefined
    });

    var onSortClick;

    if (sortId !== undefined && !!onSort) {
      onSortClick = function onSortClick() {
        onSort({
          sortId: sortId,
          sortDirection: sortDirection === _interfaces.SortDirection.Ascending ? _interfaces.SortDirection.Descending : _interfaces.SortDirection.Ascending
        });
      };
    }

    var justifyContent = 'flex-start';

    if (textAlign === 'right') {
      justifyContent = 'flex-end';
    } else if (textAlign === 'center') {
      justifyContent = 'center';
    }

    var titleText = isCurrentSortedColumn && sortDirection === _interfaces.SortDirection.Ascending ? descendingTitleText : ascendingTitleText;
    return (0, _core.jsx)(Cell, (0, _extends2.default)({
      hasStickyHeader: isCellTypeHeader ? hasStickyHeader : undefined,
      isStriped: isStriped,
      key: index,
      spacing: spacing,
      textAlign: textAlign,
      width: width
    }, headerTypeCellProps), isSortable ? (0, _core.jsx)(_TableHeaderButton.default, {
      textAlign: textAlign,
      justifyContent: justifyContent,
      onClick: onSortClick,
      sortDirection: columnSortDirection,
      spacing: spacing,
      titleText: titleText
    }, header) : (0, _core.jsx)(_layout.Row, {
      alignItems: "center",
      gridGap: "S200",
      justifyContent: justifyContent
    }, header));
  }); // Slicing the header columns to insert the actionHeader at any index.

  return (0, _core.jsx)(_html.TheadElement, null, (0, _core.jsx)(_html.TrElement, {
    "aria-rowindex": isExpandable ? 1 : undefined
  }, isActionCustomPosition ? baseColumns.slice(0, actionColumnIndex) : baseColumns, hasActionColumn && (0, _core.jsx)(_helperComponents.ActionCellTh, {
    hasStickyHeader: hasStickyHeader,
    isStriped: isStriped,
    scope: "col",
    spacing: spacing
  }, actionHeader), isActionCustomPosition && baseColumns.slice(actionColumnIndex)));
};

TableHeader.displayName = 'TableHeader';
var _default = TableHeader;
exports.default = _default;